import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Send,
  Loader2,
  Plus,
  MessageSquare,
  Mic,
  MicOff,
  Image,
  Newspaper,
  Search,
  Volume2,
  VolumeX,
  Plane,
  Building2,
  Home,
  Train,
  Ticket,
  Car,
  Shield,
  ArrowRight,
  Sparkles,
  MapPin,
  Calendar,
  Compass
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { TravelHeroMagazine } from '../components/TravelHeroMagazine';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// 100 Global Destinations - INTERNATIONAL FIRST with TRUE 4K quality images
const globalDestinations = [
  // === OPENING SEQUENCE: INTERNATIONAL DESTINATIONS ===
  { id: 1, name: 'Maldives', country: 'Maldives', iata: 'MLE', image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=3840&q=95&fit=crop' },
  { id: 2, name: 'London', country: 'United Kingdom', iata: 'LHR', image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=3840&q=95&fit=crop' },
  { id: 3, name: 'Paris', country: 'France', iata: 'CDG', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=3840&q=95&fit=crop' },
  { id: 4, name: 'Dubai', country: 'UAE', iata: 'DXB', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=3840&q=95&fit=crop' },
  { id: 5, name: 'Santorini', country: 'Greece', iata: 'JTR', image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=3840&q=95&fit=crop' },
  { id: 6, name: 'Bali', country: 'Indonesia', iata: 'DPS', image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=3840&q=95&fit=crop' },
  { id: 7, name: 'Tokyo', country: 'Japan', iata: 'NRT', image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=3840&q=95&fit=crop' },
  { id: 8, name: 'New York', country: 'USA', iata: 'JFK', image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=3840&q=95&fit=crop' },
  { id: 9, name: 'Abu Dhabi', country: 'UAE', iata: 'AUH', image: 'https://images.unsplash.com/photo-1512632578888-169bbbc64f33?w=3840&q=95&fit=crop' },
  { id: 10, name: 'Rome', country: 'Italy', iata: 'FCO', image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=3840&q=95&fit=crop' },
  { id: 11, name: 'Singapore', country: 'Singapore', iata: 'SIN', image: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=3840&q=95&fit=crop' },
  { id: 12, name: 'Barcelona', country: 'Spain', iata: 'BCN', image: 'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=3840&q=95&fit=crop' },
  { id: 13, name: 'Sydney', country: 'Australia', iata: 'SYD', image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=3840&q=95&fit=crop' },
  { id: 14, name: 'Petra', country: 'Jordan', iata: 'AMM', image: 'https://images.unsplash.com/photo-1579606032821-4e6161c81571?w=3840&q=95&fit=crop' },
  { id: 15, name: 'Amsterdam', country: 'Netherlands', iata: 'AMS', image: 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=3840&q=95&fit=crop' },
  { id: 16, name: 'Istanbul', country: 'Turkey', iata: 'IST', image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=3840&q=95&fit=crop' },
  { id: 17, name: 'Cappadocia', country: 'Turkey', iata: 'ASR', image: 'https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?w=3840&q=95&fit=crop' },
  { id: 18, name: 'Venice', country: 'Italy', iata: 'VCE', image: 'https://images.unsplash.com/photo-1514890547357-a9ee288728e0?w=3840&q=95&fit=crop' },
  { id: 19, name: 'Kyoto', country: 'Japan', iata: 'KIX', image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=3840&q=95&fit=crop' },
  { id: 20, name: 'Machu Picchu', country: 'Peru', iata: 'CUZ', image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=3840&q=95&fit=crop' },
  // First Indian destination after 20 international
  { id: 21, name: 'Udaipur', country: 'India', iata: 'UDR', image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=3840&q=95&fit=crop' },
  { id: 22, name: 'Helsinki', country: 'Finland', iata: 'HEL', image: 'https://images.unsplash.com/photo-1538332576228-eb5b4c4de6f5?w=3840&q=95&fit=crop' },
  { id: 23, name: 'Reykjavik', country: 'Iceland', iata: 'KEF', image: 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=3840&q=95&fit=crop' },
  { id: 24, name: 'Prague', country: 'Czech Republic', iata: 'PRG', image: 'https://images.unsplash.com/photo-1541849546-216549ae216d?w=3840&q=95&fit=crop' },
  { id: 25, name: 'Amman', country: 'Jordan', iata: 'AMM', image: 'https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?w=3840&q=95&fit=crop' },
  { id: 26, name: 'Bangkok', country: 'Thailand', iata: 'BKK', image: 'https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=3840&q=95&fit=crop' },
  { id: 27, name: 'Vienna', country: 'Austria', iata: 'VIE', image: 'https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=3840&q=95&fit=crop' },
  { id: 28, name: 'Florence', country: 'Italy', iata: 'FLR', image: 'https://images.unsplash.com/photo-1543429258-c5ca3d4a7f51?w=3840&q=95&fit=crop' },
  { id: 29, name: 'Mount Fuji', country: 'Japan', iata: 'NRT', image: 'https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=3840&q=95&fit=crop' },
  { id: 30, name: 'Los Angeles', country: 'USA', iata: 'LAX', image: 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=3840&q=95&fit=crop' },
  { id: 31, name: 'Jaipur', country: 'India', iata: 'JAI', image: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=3840&q=95&fit=crop' },
  { id: 32, name: 'Phuket', country: 'Thailand', iata: 'HKT', image: 'https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?w=3840&q=95&fit=crop' },
  { id: 33, name: 'Cape Town', country: 'South Africa', iata: 'CPT', image: 'https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=3840&q=95&fit=crop' },
  { id: 34, name: 'Rio de Janeiro', country: 'Brazil', iata: 'GIG', image: 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=3840&q=95&fit=crop' },
  { id: 35, name: 'Mykonos', country: 'Greece', iata: 'JMK', image: 'https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=3840&q=95&fit=crop' },
  { id: 36, name: 'Seoul', country: 'South Korea', iata: 'ICN', image: 'https://images.unsplash.com/photo-1538485399081-7191377e8241?w=3840&q=95&fit=crop' },
  { id: 37, name: 'Zurich', country: 'Switzerland', iata: 'ZRH', image: 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=3840&q=95&fit=crop' },
  { id: 38, name: 'Wadi Rum', country: 'Jordan', iata: 'AQJ', image: 'https://images.unsplash.com/photo-1553899017-a85e80cbc3b3?w=3840&q=95&fit=crop' },
  { id: 39, name: 'Edinburgh', country: 'United Kingdom', iata: 'EDI', image: 'https://images.unsplash.com/photo-1506377585622-bedcbb027afc?w=3840&q=95&fit=crop' },
  { id: 40, name: 'Miami', country: 'USA', iata: 'MIA', image: 'https://images.unsplash.com/photo-1535498730771-e735b998cd64?w=3840&q=95&fit=crop' },
  { id: 41, name: 'Agra', country: 'India', iata: 'AGR', image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=3840&q=95&fit=crop' },
  { id: 42, name: 'Kuala Lumpur', country: 'Malaysia', iata: 'KUL', image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=3840&q=95&fit=crop' },
  { id: 43, name: 'Athens', country: 'Greece', iata: 'ATH', image: 'https://images.unsplash.com/photo-1555993539-1732b0258235?w=3840&q=95&fit=crop' },
  { id: 44, name: 'Nice', country: 'France', iata: 'NCE', image: 'https://images.unsplash.com/photo-1491166617655-0723a0999cfc?w=3840&q=95&fit=crop' },
  { id: 45, name: 'Hawaii', country: 'USA', iata: 'HNL', image: 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=3840&q=95&fit=crop' },
  { id: 46, name: 'Amalfi Coast', country: 'Italy', iata: 'NAP', image: 'https://images.unsplash.com/photo-1534113414509-0eec2bfb493f?w=3840&q=95&fit=crop' },
  { id: 47, name: 'Cairo', country: 'Egypt', iata: 'CAI', image: 'https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=3840&q=95&fit=crop' },
  { id: 48, name: 'Marrakech', country: 'Morocco', iata: 'RAK', image: 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?w=3840&q=95&fit=crop' },
  { id: 49, name: 'San Francisco', country: 'USA', iata: 'SFO', image: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=3840&q=95&fit=crop' },
  { id: 50, name: 'Stockholm', country: 'Sweden', iata: 'ARN', image: 'https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=3840&q=95&fit=crop' },
  { id: 51, name: 'Goa', country: 'India', iata: 'GOI', image: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=3840&q=95&fit=crop' },
  { id: 52, name: 'Osaka', country: 'Japan', iata: 'KIX', image: 'https://images.unsplash.com/photo-1590559899731-a382839e5549?w=3840&q=95&fit=crop' },
  { id: 53, name: 'Budapest', country: 'Hungary', iata: 'BUD', image: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=3840&q=95&fit=crop' },
  { id: 54, name: 'Madrid', country: 'Spain', iata: 'MAD', image: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=3840&q=95&fit=crop' },
  { id: 55, name: 'Lisbon', country: 'Portugal', iata: 'LIS', image: 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=3840&q=95&fit=crop' },
  { id: 56, name: 'Melbourne', country: 'Australia', iata: 'MEL', image: 'https://images.unsplash.com/photo-1514395462725-fb4566210144?w=3840&q=95&fit=crop' },
  { id: 57, name: 'Geneva', country: 'Switzerland', iata: 'GVA', image: 'https://images.unsplash.com/photo-1573108037329-37aa135a142e?w=3840&q=95&fit=crop' },
  { id: 58, name: 'Copenhagen', country: 'Denmark', iata: 'CPH', image: 'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=3840&q=95&fit=crop' },
  { id: 59, name: 'Oslo', country: 'Norway', iata: 'OSL', image: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=3840&q=95&fit=crop' },
  { id: 60, name: 'Chiang Mai', country: 'Thailand', iata: 'CNX', image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?w=3840&q=95&fit=crop' },
  { id: 61, name: 'Delhi', country: 'India', iata: 'DEL', image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=3840&q=95&fit=crop' },
  { id: 62, name: 'Mumbai', country: 'India', iata: 'BOM', image: 'https://images.unsplash.com/photo-1529253355930-ddbe423a2ac7?w=3840&q=95&fit=crop' },
  { id: 63, name: 'Queenstown', country: 'New Zealand', iata: 'ZQN', image: 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=3840&q=95&fit=crop' },
  { id: 64, name: 'Auckland', country: 'New Zealand', iata: 'AKL', image: 'https://images.unsplash.com/photo-1507097634215-e82e6b518529?w=3840&q=95&fit=crop' },
  { id: 65, name: 'Las Vegas', country: 'USA', iata: 'LAS', image: 'https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=3840&q=95&fit=crop' },
  { id: 66, name: 'Interlaken', country: 'Switzerland', iata: 'ZRH', image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=3840&q=95&fit=crop' },
  { id: 67, name: 'Busan', country: 'South Korea', iata: 'PUS', image: 'https://images.unsplash.com/photo-1596648007962-7a298e24ed17?w=3840&q=95&fit=crop' },
  { id: 68, name: 'Milan', country: 'Italy', iata: 'MXP', image: 'https://images.unsplash.com/photo-1520440229-6469a149ac59?w=3840&q=95&fit=crop' },
  { id: 69, name: 'Seville', country: 'Spain', iata: 'SVQ', image: 'https://images.unsplash.com/photo-1555862124-94036092ab14?w=3840&q=95&fit=crop' },
  { id: 70, name: 'Zanzibar', country: 'Tanzania', iata: 'ZNZ', image: 'https://images.unsplash.com/photo-1582878826629-29b7ad1cdc43?w=3840&q=95&fit=crop' },
  { id: 71, name: 'Varanasi', country: 'India', iata: 'VNS', image: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=3840&q=95&fit=crop' },
  { id: 72, name: 'Great Barrier Reef', country: 'Australia', iata: 'CNS', image: 'https://images.unsplash.com/photo-1587139223877-04cb899fa3e8?w=3840&q=95&fit=crop' },
  { id: 73, name: 'Banff', country: 'Canada', iata: 'YYC', image: 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=3840&q=95&fit=crop' },
  { id: 74, name: 'Toronto', country: 'Canada', iata: 'YYZ', image: 'https://images.unsplash.com/photo-1517090504586-fde19ea6066f?w=3840&q=95&fit=crop' },
  { id: 75, name: 'Vancouver', country: 'Canada', iata: 'YVR', image: 'https://images.unsplash.com/photo-1559511260-66a654ae982a?w=3840&q=95&fit=crop' },
  { id: 76, name: 'Buenos Aires', country: 'Argentina', iata: 'EZE', image: 'https://images.unsplash.com/photo-1612294037637-ec328d0e075e?w=3840&q=95&fit=crop' },
  { id: 77, name: 'Cancun', country: 'Mexico', iata: 'CUN', image: 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?w=3840&q=95&fit=crop' },
  { id: 78, name: 'Serengeti', country: 'Tanzania', iata: 'JRO', image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=3840&q=95&fit=crop' },
  { id: 79, name: 'Grand Canyon', country: 'USA', iata: 'PHX', image: 'https://images.unsplash.com/photo-1474044159687-1ee9f3a51722?w=3840&q=95&fit=crop' },
  { id: 80, name: 'Hiroshima', country: 'Japan', iata: 'HIJ', image: 'https://images.unsplash.com/photo-1576675784201-0e142b423952?w=3840&q=95&fit=crop' },
  { id: 81, name: 'Kerala', country: 'India', iata: 'COK', image: 'https://images.unsplash.com/photo-1593693411515-c20261bcad6e?w=3840&q=95&fit=crop' },
  { id: 82, name: 'Bangalore', country: 'India', iata: 'BLR', image: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=3840&q=95&fit=crop' },
  { id: 83, name: 'Lyon', country: 'France', iata: 'LYS', image: 'https://images.unsplash.com/photo-1524396309943-e03f5249f002?w=3840&q=95&fit=crop' },
  { id: 84, name: 'Bordeaux', country: 'France', iata: 'BOD', image: 'https://images.unsplash.com/photo-1565018054866-968e244671af?w=3840&q=95&fit=crop' },
  { id: 85, name: 'Ibiza', country: 'Spain', iata: 'IBZ', image: 'https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=3840&q=95&fit=crop' },
  { id: 86, name: 'Dead Sea', country: 'Jordan', iata: 'AMM', image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=3840&q=95&fit=crop' },
  { id: 87, name: 'Jakarta', country: 'Indonesia', iata: 'CGK', image: 'https://images.unsplash.com/photo-1555899434-94d1368aa7af?w=3840&q=95&fit=crop' },
  { id: 88, name: 'Yogyakarta', country: 'Indonesia', iata: 'JOG', image: 'https://images.unsplash.com/photo-1596402184320-417e7178b2cd?w=3840&q=95&fit=crop' },
  { id: 89, name: 'Antalya', country: 'Turkey', iata: 'AYT', image: 'https://images.unsplash.com/photo-1593238739364-18cfde865989?w=3840&q=95&fit=crop' },
  { id: 90, name: 'Langkawi', country: 'Malaysia', iata: 'LGK', image: 'https://images.unsplash.com/photo-1509023464722-18d996393ca8?w=3840&q=95&fit=crop' },
  { id: 91, name: 'Chennai', country: 'India', iata: 'MAA', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=3840&q=95&fit=crop' },
  { id: 92, name: 'Manchester', country: 'United Kingdom', iata: 'MAN', image: 'https://images.unsplash.com/photo-1515586838455-8f8f940d6853?w=3840&q=95&fit=crop' },
  { id: 93, name: 'Oxford', country: 'United Kingdom', iata: 'LHR', image: 'https://images.unsplash.com/photo-1590069261209-f8e9b8642343?w=3840&q=95&fit=crop' },
  { id: 94, name: 'Cambridge', country: 'United Kingdom', iata: 'STN', image: 'https://images.unsplash.com/photo-1574236170880-fbc2f4df89d9?w=3840&q=95&fit=crop' },
  { id: 95, name: 'Marseille', country: 'France', iata: 'MRS', image: 'https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?w=3840&q=95&fit=crop' },
  { id: 96, name: 'Seattle', country: 'USA', iata: 'SEA', image: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=3840&q=95&fit=crop' },
  { id: 97, name: 'Washington DC', country: 'USA', iata: 'IAD', image: 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=3840&q=95&fit=crop' },
  { id: 98, name: 'Chicago', country: 'USA', iata: 'ORD', image: 'https://images.unsplash.com/photo-1494522855154-9297ac14b55f?w=3840&q=95&fit=crop' },
  { id: 99, name: 'Sharjah', country: 'UAE', iata: 'SHJ', image: 'https://images.unsplash.com/photo-1578895101408-1a36b834405b?w=3840&q=95&fit=crop' },
  { id: 100, name: 'Malé', country: 'Maldives', iata: 'MLE', image: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=3840&q=95&fit=crop' },
];

// Travel Services Data
const travelServices = [
  { id: 'flights', name: 'Flights', description: 'Find the best flights with AI', icon: Plane, route: '/travel', gradient: 'from-pink-500/20 to-purple-600/20', borderGlow: 'rgba(236, 72, 153, 0.4)', iconColor: 'text-pink-400' },
  { id: 'hotels', name: 'Hotels', description: 'Stay your way', icon: Building2, route: '/stays', gradient: 'from-purple-500/20 to-indigo-600/20', borderGlow: 'rgba(139, 92, 246, 0.4)', iconColor: 'text-purple-400' },
  { id: 'tours', name: 'Tours', description: 'Explore tours & activities', icon: Ticket, route: '/tours', gradient: 'from-amber-500/20 to-orange-600/20', borderGlow: 'rgba(245, 158, 11, 0.4)', iconColor: 'text-amber-400' },
  { id: 'villas', name: 'Villas & Homestays', description: 'Unique stays, unforgettable trips', icon: Home, route: '/stays', gradient: 'from-cyan-500/20 to-teal-600/20', borderGlow: 'rgba(6, 182, 212, 0.4)', iconColor: 'text-cyan-400' },
  { id: 'trains', name: 'Trains', description: 'Travel across India with ease', icon: Train, route: '/trains', gradient: 'from-blue-500/20 to-indigo-600/20', borderGlow: 'rgba(59, 130, 246, 0.4)', iconColor: 'text-blue-400' },
  { id: 'cabs', name: 'Cabs', description: 'Airport & city rides', icon: Car, route: '/cabs', gradient: 'from-violet-500/20 to-purple-600/20', borderGlow: 'rgba(139, 92, 246, 0.4)', iconColor: 'text-violet-400' },
  { id: 'insurance', name: 'Travel Insurance', description: 'Travel safe, travel worry-free', icon: Shield, route: '/insurance', gradient: 'from-emerald-500/20 to-teal-600/20', borderGlow: 'rgba(16, 185, 129, 0.4)', iconColor: 'text-emerald-400' },
  { id: 'experiences', name: 'Experiences', description: 'Events, concerts & activities', icon: Sparkles, route: '/experiences', gradient: 'from-rose-500/20 to-pink-600/20', borderGlow: 'rgba(244, 63, 94, 0.4)', iconColor: 'text-rose-400' }
];

const sampleRecentChats = [
  { id: 1, title: 'Plan a 7 day Europe trip...', time: '2 hours ago' },
  { id: 2, title: 'Best resorts in Bali?', time: '5 hours ago' },
  { id: 3, title: 'Budget trip to Vietnam', time: '1 day ago' },
  { id: 4, title: 'Train options from Delhi...', time: '2 days ago' },
  { id: 5, title: 'Visa requirements for Japan...', time: '3 days ago' },
  { id: 6, title: 'Create an itinerary for...', time: '4 days ago' }
];

// Neon glow keyframes - continuous shimmer animation
const neonShimmerKeyframes = `
@keyframes neonShimmer {
  0%, 100% {
    filter: drop-shadow(0 0 8px var(--neon-color)) drop-shadow(0 0 16px var(--neon-color));
    opacity: 1;
  }
  50% {
    filter: drop-shadow(0 0 12px var(--neon-color)) drop-shadow(0 0 24px var(--neon-color)) drop-shadow(0 0 32px var(--neon-color));
    opacity: 0.95;
  }
}
@keyframes neonPulse {
  0%, 100% {
    box-shadow: 0 0 10px var(--neon-color), 0 0 20px var(--neon-color), inset 0 0 8px var(--neon-color-dim);
  }
  50% {
    box-shadow: 0 0 15px var(--neon-color), 0 0 30px var(--neon-color), 0 0 45px var(--neon-color), inset 0 0 12px var(--neon-color-dim);
  }
}
`;

// Service Card Component with Premium Neon Glow Animation
const ServiceCard = ({ service, index }) => {
  const navigate = useNavigate();
  const Icon = service.icon;

  // Inject keyframes once
  React.useEffect(() => {
    if (!document.getElementById('neon-shimmer-styles')) {
      const style = document.createElement('style');
      style.id = 'neon-shimmer-styles';
      style.textContent = neonShimmerKeyframes;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05, duration: 0.3 }}
      onClick={() => navigate(service.route)}
      className="group relative cursor-pointer"
      data-testid={`service-card-${service.id}`}
      style={{ '--neon-color': service.borderGlow, '--neon-color-dim': service.borderGlow.replace('0.4', '0.15') }}
    >
      {/* Continuous neon glow border - always visible, intensifies on hover */}
      <div 
        className="absolute -inset-[1px] rounded-xl transition-all duration-500 blur-[2px]"
        style={{ 
          background: `linear-gradient(135deg, ${service.borderGlow}, transparent 70%)`,
          boxShadow: `0 0 15px ${service.borderGlow}, 0 0 30px ${service.borderGlow.replace('0.4', '0.2')}`,
          animation: 'neonPulse 3s ease-in-out infinite',
          animationDelay: `${index * 0.2}s`
        }}
      />
      <div className={`relative h-full p-3 rounded-xl bg-gradient-to-br ${service.gradient} backdrop-blur-xl border border-white/10 group-hover:border-white/30 transition-all duration-300`}
        style={{ 
          boxShadow: `inset 0 0 20px ${service.borderGlow.replace('0.4', '0.1')}`
        }}
      >
        {/* Icon with continuous neon shimmer */}
        <div 
          className="relative"
          style={{ 
            '--neon-color': service.borderGlow,
            animation: 'neonShimmer 2.5s ease-in-out infinite',
            animationDelay: `${index * 0.15}s`
          }}
        >
          <Icon 
            className={`w-6 h-6 ${service.iconColor} stroke-[1.5] mb-2`} 
            style={{ 
              filter: `drop-shadow(0 0 8px ${service.borderGlow}) drop-shadow(0 0 16px ${service.borderGlow})`,
            }} 
          />
        </div>
        <h3 className="text-white font-medium text-xs mb-0.5" style={{ textShadow: `0 0 10px ${service.borderGlow.replace('0.4', '0.3')}` }}>{service.name}</h3>
        <p className="text-white/40 text-[10px] leading-tight line-clamp-1">{service.description}</p>
      </div>
    </motion.div>
  );
};

// Cover Video URL - User-provided MP4
const COVER_VIDEO_URL = 'https://customer-assets-wrfwihn1.emergentagent.net/job_365fb2ed-14d7-43a9-bcd0-91c03dcab0b9/artifacts/9q9j9rt3_COVER%20VIDEO.mp4';

// PREMIUM CINEMATIC VIDEO COVER COMPONENT - Seamless loop, no controls
const VideoCover = ({ onNavigate }) => {
  const videoRef = React.useRef(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Handle timeupdate for seamless loop
    const handleTimeUpdate = () => {
      if (video.duration && video.currentTime >= video.duration - 0.1) {
        video.currentTime = 0;
      }
    };

    // Handle video ready states
    const handleCanPlayThrough = () => {
      setIsLoaded(true);
      video.play().catch(console.log);
    };

    const handleLoadedData = () => {
      setIsLoaded(true);
      video.play().catch(console.log);
    };

    const handleError = (e) => {
      console.log('Video error:', e);
      setHasError(true);
    };

    const handleLoadStart = () => {
      console.log('Video loading started');
    };

    const handleProgress = () => {
      // Video is buffering
      if (video.buffered.length > 0) {
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        if (bufferedEnd > 1 && !isLoaded) {
          setIsLoaded(true);
          video.play().catch(console.log);
        }
      }
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('canplaythrough', handleCanPlayThrough);
    video.addEventListener('loadeddata', handleLoadedData);
    video.addEventListener('error', handleError);
    video.addEventListener('loadstart', handleLoadStart);
    video.addEventListener('progress', handleProgress);

    // Attempt to play immediately (for already-cached videos)
    if (video.readyState >= 3) {
      setIsLoaded(true);
      video.play().catch(console.log);
    }

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('canplaythrough', handleCanPlayThrough);
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('error', handleError);
      video.removeEventListener('loadstart', handleLoadStart);
      video.removeEventListener('progress', handleProgress);
    };
  }, [isLoaded]);

  return (
    <div
      onClick={onNavigate}
      className="absolute inset-0 cursor-pointer group"
      data-testid="video-cover-clickable"
    >
      {/* Loading placeholder - shows while video buffers */}
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/60 to-pink-900/40 flex items-center justify-center">
          <div className="text-center">
            <div className="w-10 h-10 border-2 border-purple-400 border-t-transparent rounded-full animate-spin mx-auto mb-2" />
            <p className="text-white/50 text-xs">Loading cinematic experience...</p>
          </div>
        </div>
      )}

      {/* Error fallback - shows a gradient background if video fails */}
      {hasError && (
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/70 via-indigo-900/60 to-pink-900/50" />
      )}

      {/* Video element - autoplay, muted, loop, playsInline, preload */}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${isLoaded && !hasError ? 'opacity-100' : 'opacity-0'}`}
        style={{ objectFit: 'cover' }}
      >
        <source src={COVER_VIDEO_URL} type="video/mp4" />
      </video>
      
      {/* Subtle gradient overlay for text readability at bottom */}
      <div className="absolute inset-0 pointer-events-none" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0.7) 100%)'
      }} />
      
      {/* Purple/Magenta atmospheric glow corners */}
      <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at 10% 90%, rgba(168, 85, 247, 0.15) 0%, transparent 40%), radial-gradient(ellipse at 90% 10%, rgba(236, 72, 153, 0.1) 0%, transparent 40%)'
      }} />
      
      {/* Bottom CTA overlay - Book Flights - responsive */}
      <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5 md:p-6 flex items-center justify-between">
        <div>
          <h3 
            className="text-white text-sm sm:text-lg md:text-xl font-medium mb-0.5"
            style={{ textShadow: '0 2px 20px rgba(0,0,0,0.8)' }}
          >
            Discover Your Next Journey
          </h3>
          <p 
            className="text-white/60 text-[10px] sm:text-xs md:text-sm"
            style={{ textShadow: '0 2px 10px rgba(0,0,0,0.8)' }}
          >
            Click to explore flights worldwide
          </p>
        </div>
        
        {/* Subtle animated CTA - responsive */}
        <div className="flex items-center gap-1.5 sm:gap-2 text-white/60 group-hover:text-white transition-all duration-500">
          <div 
            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center border border-white/20 group-hover:border-purple-400/60 group-hover:bg-purple-500/30 transition-all duration-500"
            style={{ boxShadow: '0 0 20px rgba(168, 85, 247, 0.3)' }}
          >
            <Plane className="w-4 h-4 sm:w-5 sm:h-5" />
          </div>
          <span className="hidden md:inline text-sm tracking-wide font-light group-hover:text-purple-300 transition-colors">
            Book Flights
          </span>
          <ArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform duration-500" />
        </div>
      </div>
    </div>
  );
};

// Keep old DestinationCover for reference destinations in sidebar only
const DestinationCover = ({ destination, onNavigate }) => {
  return (
    <motion.div
      key={destination.id}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      onClick={() => onNavigate(destination)}
      className="absolute inset-0 cursor-pointer group"
      data-testid={`destination-cover-${destination.id}`}
    >
      <motion.div 
        className="absolute inset-0"
        initial={{ scale: 1 }}
        animate={{ scale: 1.05 }}
        transition={{ duration: 2.5, ease: "linear" }}
      >
        <img
          src={destination.image}
          alt={destination.name}
          className="w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.5) 65%, rgba(0,0,0,0.92) 100%)'
      }} />
      <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at 20% 90%, rgba(168, 85, 247, 0.2) 0%, transparent 50%), radial-gradient(ellipse at 85% 15%, rgba(236, 72, 153, 0.12) 0%, transparent 50%)'
      }} />
      <div className="absolute bottom-0 right-0 left-0 p-6 md:p-8 flex flex-col items-end text-right">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-1"
            style={{ 
              fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif',
              textShadow: '0 0 80px rgba(168, 85, 247, 0.6), 0 4px 40px rgba(0,0,0,0.9), 0 2px 4px rgba(0,0,0,1)',
              letterSpacing: '0.08em',
              fontStyle: 'italic'
            }}
          >
            {destination.name}
          </h2>
          <p 
            className="text-white/70 text-xs md:text-sm tracking-[0.3em] uppercase font-light"
            style={{ textShadow: '0 2px 15px rgba(0,0,0,0.8)' }}
          >
            {destination.country}
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.4 }}
          className="mt-4 flex items-center gap-2 text-white/50 group-hover:text-white/80 transition-all duration-500"
        >
          <div className="w-7 h-7 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20 group-hover:border-purple-400/50 group-hover:bg-purple-500/20 transition-all duration-500"
            style={{ boxShadow: '0 0 15px rgba(168, 85, 247, 0.25)' }}
          >
            <Plane className="w-3.5 h-3.5" />
          </div>
          <span className="text-xs tracking-[0.12em] uppercase font-light">Explore Flights</span>
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform duration-500" />
        </motion.div>
      </div>
    </motion.div>
  );
};

// Main Page Component
export default function AiraEchoMainPage() {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [currentDestIndex, setCurrentDestIndex] = useState(0);
  const inputRef = useRef(null);
  const recognitionRef = useRef(null);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  };

  const userName = user?.name?.split(' ')[0] || 'Traveler';

  // Auto-rotate destinations every 2.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDestIndex(prev => (prev + 1) % globalDestinations.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const handleDestinationClick = (destination) => {
    navigate('/travel', { state: { prefilledDestination: { city: destination.name, iata: destination.iata, country: destination.country } } });
  };

  useEffect(() => {
    const loadSessions = async () => {
      if (!token) return;
      try {
        const response = await axios.get(`${API_URL}/api/chat/sessions`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true });
        setSessions(response.data.slice(0, 6));
      } catch (error) { console.log('Using sample chats'); }
    };
    loadSessions();
  }, [token]);

  useEffect(() => {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = true;
      recognitionRef.current.lang = 'en-US';
    }
    return () => { if (recognitionRef.current) recognitionRef.current.abort(); };
  }, []);

  const startListening = useCallback(() => {
    if (!recognitionRef.current) { toast.error('Speech recognition not supported'); return; }
    recognitionRef.current.onstart = () => setIsListening(true);
    recognitionRef.current.onresult = (event) => { setInput(Array.from(event.results).map(r => r[0].transcript).join('')); };
    recognitionRef.current.onerror = () => setIsListening(false);
    recognitionRef.current.onend = () => setIsListening(false);
    recognitionRef.current.start();
  }, []);

  const stopListening = useCallback(() => { if (recognitionRef.current) recognitionRef.current.stop(); setIsListening(false); }, []);

  const handleSubmit = async (e) => { e?.preventDefault(); if (!input.trim() || loading) return; navigate('/chat', { state: { initialMessage: input } }); };

  const handleQuickAction = (action) => {
    const actions = { image: 'Create an image of ', news: 'What are the latest travel news?', search: 'Search the web for ' };
    setInput(actions[action] || '');
    inputRef.current?.focus();
  };

  // Handler for video cover click - navigate to Flight Booking
  const handleVideoCoverClick = () => {
    navigate('/travel');
  };

  const displayChats = sessions.length > 0 ? sessions : sampleRecentChats;
  const currentDestination = globalDestinations[currentDestIndex];

  // Handler for TravelHeroMagazine service navigation
  const handleHeroServiceNavigate = (service) => {
    const routes = {
      flights: '/travel',
      hotels: '/stays',
      tours: '/tours',
      cabs: '/cabs',
      insurance: '/insurance',
      'ai planner': '/trip-planner',
    };
    navigate(routes[service] || '/travel');
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col overflow-hidden" data-testid="aira-echo-main">
      {/* HERO SECTION: Magazine-Style Travel Collage */}
      <div className="px-4 pt-3 pb-3">
        <div 
          data-testid="cover-travel-hero"
          style={{
            boxShadow: '0 0 80px rgba(245, 158, 11, 0.12), 0 0 60px rgba(168, 85, 247, 0.15), 0 20px 60px rgba(0,0,0,0.5)',
          }}
          className="mb-4"
        >
          <TravelHeroMagazine 
            onNavigate={handleHeroServiceNavigate}
            userName={userName}
            greeting={getGreeting()}
          />
        </div>
        
        {/* Service Cards Row */}
        <div className="mb-3">
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className="w-4 h-4 text-amber-400" style={{ filter: 'drop-shadow(0 0 6px rgba(245, 158, 11, 0.5))' }} />
            <h2 className="text-[var(--text-primary)] font-medium text-sm">Plan Your Next Journey</h2>
          </div>
          {/* Mobile: 4 cols, Tablet: 7 cols, Desktop: 7 cols */}
          <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
            {travelServices.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </div>

      {/* Main Content - Three Columns on desktop, stacked on mobile */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-3 px-4 pb-4">
        {/* Left Column */}
        <div className="lg:col-span-3 flex flex-col gap-3">
          <button
            onClick={() => navigate('/chat')}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 text-white font-medium hover:opacity-90 transition-all text-sm"
            style={{ boxShadow: '0 0 25px rgba(236, 72, 153, 0.3)' }}
            data-testid="new-chat-btn"
          >
            <Plus className="w-4 h-4" />
            New Chat
          </button>

          <div className="flex-1 rounded-xl bg-[var(--bg-card)] backdrop-blur-xl border border-[var(--border-color)] p-3 overflow-hidden">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-[var(--text-primary)] font-medium text-xs">Recent Chats</h3>
              <button className="text-purple-400 text-[10px] hover:text-purple-300 transition-colors">View all</button>
            </div>
            <div className="space-y-1 overflow-y-auto max-h-[200px] custom-scrollbar">
              {displayChats.map((chat, idx) => (
                <motion.div
                  key={chat.id || idx}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.05 }}
                  className="flex items-center gap-2 p-2 rounded-lg hover:bg-[var(--bg-card-hover)] cursor-pointer transition-colors group"
                  onClick={() => navigate('/chat')}
                >
                  <MessageSquare className="w-3.5 h-3.5 text-[var(--text-muted)] flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-[var(--text-secondary)] text-xs truncate group-hover:text-[var(--text-primary)] transition-colors">{chat.title || 'New Chat'}</p>
                    <p className="text-[var(--text-muted)] text-[10px]">{chat.time || 'Recently'}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* Middle Column - AIRA Chat */}
        <div className="lg:col-span-6">
          <div className="h-full rounded-xl bg-[var(--bg-card)] backdrop-blur-xl border border-[var(--border-color)] p-4 flex flex-col">
            <div className="mb-3">
              <h3 className="text-[var(--text-primary)] font-semibold text-lg">AIRA Chat</h3>
              <p className="text-[var(--text-tertiary)] text-xs">Your intelligent AI travel companion</p>
            </div>

            <div className="flex-1 flex items-center justify-center min-h-[140px]">
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center mx-auto mb-3 border border-purple-500/20"
                  style={{ boxShadow: '0 0 30px rgba(168, 85, 247, 0.2)' }}
                >
                  <MessageSquare className="w-8 h-8 text-purple-400/60" />
                </div>
                <h4 className="text-[var(--text-primary)] font-medium text-base mb-1">Start a Conversation</h4>
                <p className="text-[var(--text-tertiary)] text-xs max-w-xs mx-auto">Ask AIRA anything - travel planning, bookings, research and more.</p>
              </div>
            </div>

            <div className="flex items-center gap-2 mb-2 flex-wrap">
              {[{ action: 'image', icon: Image, label: 'Create Image' }, { action: 'news', icon: Newspaper, label: 'Latest News' }, { action: 'search', icon: Search, label: 'Web Search' }].map(({ action, icon: Icon, label }) => (
                <button key={action} onClick={() => handleQuickAction(action)} className="flex items-center gap-1 px-2 py-1 rounded-full bg-[var(--bg-input)] text-[var(--text-secondary)] hover:bg-[var(--bg-card-hover)] hover:text-[var(--text-primary)] transition-all text-[10px] border border-[var(--border-color)]">
                  <Icon className="w-3 h-3" />{label}
                </button>
              ))}
            </div>

            <form onSubmit={handleSubmit} className="relative">
              <div className="flex items-center gap-2 p-2 rounded-xl bg-[var(--bg-input)] border border-[var(--border-color)]">
                <input
                  ref={inputRef}
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Ask AIRA ECHO anything..."
                  className="flex-1 bg-transparent border-none outline-none text-[var(--text-primary)] placeholder-[var(--text-muted)] text-sm px-2 py-1"
                  disabled={loading}
                  data-testid="chat-input"
                />
                <button type="button" onClick={isListening ? stopListening : startListening} disabled={loading}
                  className={`p-1.5 rounded-lg transition-all ${isListening ? 'bg-red-500/20 text-red-400 animate-pulse' : 'hover:bg-[var(--bg-card-hover)] text-[var(--text-muted)] hover:text-[var(--text-primary)]'}`}
                  data-testid="voice-input-btn"
                >
                  {isListening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
                </button>
                <button type="button" className="p-1.5 rounded-lg text-[var(--text-muted)] hover:bg-[var(--bg-card-hover)] hover:text-[var(--text-secondary)] transition-all">
                  <VolumeX className="w-4 h-4" />
                </button>
                <button type="submit" disabled={loading || !input.trim()}
                  className="p-1.5 rounded-lg bg-gradient-to-r from-pink-500 to-purple-600 text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all hover:opacity-90"
                  data-testid="send-message-btn"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Right Column */}
        <div className="lg:col-span-3 flex flex-col gap-3">
          <div className="rounded-xl bg-[var(--bg-card)] backdrop-blur-xl border border-[var(--border-color)] p-3">
            <div className="flex items-center gap-2 mb-2">
              <Sparkles className="w-3.5 h-3.5 text-purple-400" />
              <h3 className="text-[var(--text-primary)] font-medium text-xs">Popular Destinations</h3>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {['Dubai', 'Bali', 'Paris', 'Tokyo', 'Maldives', 'London'].map((dest, idx) => (
                <button key={idx} onClick={() => { const d = globalDestinations.find(x => x.name === dest); d && handleDestinationClick(d); }}
                  className="px-2 py-1 rounded-full bg-[var(--bg-input)] text-[var(--text-secondary)] text-[10px] hover:bg-purple-500/20 hover:text-purple-500 border border-[var(--border-color)] hover:border-purple-500/30 transition-all"
                >
                  {dest}
                </button>
              ))}
            </div>
          </div>

          <div className="flex-1 rounded-xl bg-[var(--bg-card)] backdrop-blur-xl border border-[var(--border-color)] p-3">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Calendar className="w-3.5 h-3.5 text-cyan-400" />
                <h3 className="text-[var(--text-primary)] font-medium text-xs">Your Upcoming Trips</h3>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center py-6">
              <div className="w-12 h-12 rounded-full bg-[var(--bg-input)] flex items-center justify-center mb-2 border border-[var(--border-color)]">
                <MapPin className="w-6 h-6 text-[var(--text-muted)]" />
              </div>
              <p className="text-[var(--text-tertiary)] text-xs text-center mb-1">No upcoming trips</p>
              <p className="text-[var(--text-muted)] text-[10px] text-center mb-3">Let AIRA plan your next adventure!</p>
              <button onClick={() => navigate('/trip-planner')}
                className="px-3 py-1.5 rounded-lg bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30 text-purple-500 text-xs hover:bg-purple-500/30 transition-all"
                data-testid="plan-trip-empty-btn"
              >
                Plan a Trip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
